export default __webpack_public_path__ + "./fonts/green-dot.57c5b441.svg";